<template>
  <div class="py-2">
    <!--    <div style="display: block">-->
    <!--      <el-dialog width="60vw" title="Chi tiết công việc" v-if="isShowTodoDetail"-->
    <!--                 :visible.sync="isShowTodoDetail" :destroy-on-close="true">-->
    <!--        <TodoDetail :selected-account="{accountId:accountId}" :todo-item="params.item"-->
    <!--                    @closeDialog="isShowTodoDetail = false" />-->
    <!--      </el-dialog>-->
    <!--    </div>-->
    <div
      class="px-12 fw-700 font-14 mb-1"
      style="color: #0a58c0">
      {{ item.description }}
    </div>
    <div
      class="px-12 mb-1 font-14 fw-300"
      style="color: #373c41">
      {{ item.content }}
    </div>
    <el-divider class="mb-2" />

    <div class="px-12 mb-1 d-flex align-items-start">
      <img
        src="/assets/icon/ic_task_message.svg"
        class="me-2 mt-1" />
      <div class="d-flex flex-column">
        <span class="fw-semibold"></span>
        {{ getMessageTitle() }}
        <span
          class="mb-2"
          v-html="getStatus(item, accountId)"></span>
      </div>
    </div>

    <div class="px-12">
      <el-button
        size="small"
        type="primary"
        @click="remidTask()"
        v-if="isRemidTask()">
        <span class="font-13 fw-400">Nhắc nhở</span>
      </el-button>
      <el-button
        size="small"
        type="primary"
        @click="acceptTask(item, accountId)"
        v-if="isAcceptTask()">
        <span class="font-13 fw-400">Nhận việc</span>
      </el-button>
      <el-button
        size="mini"
        type="primary"
        v-if="isFinishTask()"
        @click="finishTask(item, accountId)">
        <span class="font-13 fw-400">Hoàn thành</span>
      </el-button>

      <el-popover
        v-model="hidden"
        placement="bottom"
        width="300"
        trigger="click">
        <el-input
          type="textarea"
          placeholder="Nhập nội dung tin nhắn"
          :row="2"
          v-model="messageText"></el-input>
        <div class="d-flex justify-content-end">
          <el-button
            type="primary"
            size="small"
            class="mt-2"
            @click="sendMessage()">
            Gửi
          </el-button>
        </div>
        <el-button
          class="mx-2"
          size="small"
          plain
          type="primary" 
          slot="reference">
          Trả lời
        </el-button>
      </el-popover>
      <el-button
        @click="openTodo(message, item)"
        size="small mb-1">
        Xem chi tiết
      </el-button>
    </div>
  </div>
</template>

<script>

export default {
  name: "ChatTodo",
  props: {
    accountId: {
      type: String,
    },
    message: {
      type: Object,
    },
    members: {
      type: Array,
    },
  },
  components: {
  },
  data() {
    return {
      hidden: false,
      messageText: "",
      isShowTodoDetail: false,
    };
  },
  computed: {
    item() {
      let item = JSON.parse(JSON.parse(this.message.content).params).item;
      return item;
    },
  },
  methods: {
    sendMessage() {
      let message = this.item.extra;
      let req = {
        conversationId: this.app.selectedConversation.id,
        toId: this.app.selectedConversation.toId,
        accountId: this.app.selectedConversation.accountId,
        message: this.messageText,
        ownerId: this.item.creator,
        replyMsgId: message.msgId,
        replyMsgClientId: this.message.cliMsgId,
        replyMsgTs: this.message.ts,
        replyMsg: this.item.content,
      };

      let url;
      if (message.isGroup) {
        url = "/api/message/replyGroupMessage";
      } else {
        url = "/api/message/replyMessage";
      }
      this.$http
        .post(url, req)
        .then(() => {})
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra ");
        })
        .finally(() => {
          this.messageText = "";
          this.hidden = false;
        });
    },

    // acceptTask(item) {
    //   let req = {
    //     accountId: this.accountId,
    //     params: JSON.stringify({ id: item.item.id, status: 0 })
    //   };
    //   this.$http.post("/api/todo/status", req).then(s => {
    //     if (s.data.error_code === 0) {
    //       this.alert("success", "Thao tác thành công");
    //     }
    //   });
    // },
    remidTask() {
      this.ding(this.item, this.accountId);
    },
    isAcceptTask() {
      if (this.item.status === 1) return false;
      if (this.accountId !== this.item.creator) {
        let item = this.item.assignees.find((s) => s.userId === this.accountId);
        if (item && item.status === -1) {
          return true;
        }
      }
      return false;
    },
    isFinishTask() {
      if (this.item.status === 1) return false;
      if (this.accountId === this.item.creator) {
        if (this.item.assignees.find((s) => s.userId === this.item.creator)) {
          return true;
        }
      }
      return false;
    },
    isRemidTask() {
      if (this.item.status === 1) return false;
      if (this.accountId === this.item.creator) {
        let userIds = this.item.assignees.map((s) => s.userId);
        if (!userIds.includes(this.item.creator)) {
          return true;
        }
      }
      return false;
    },
    getMessageTitle() {
      if (this.members && this.members.length > 0) {
        let item = this.members.find((s) => s.id == this.item.creator);
        if (item) {
          return item.name + " đã giao việc từ tin nhắn này cho " + this.item.assignees.length + " người.";
        }
      }
      return "Giao việc";
    },
    // getStatus() {
    //   if (this.params.item.status === -1) {
    //     return "Chưa nhận";
    //   }
    //   if (this.params.item.status === 1) {
    //     return "Đã hoàn thành";
    //   }
    //   return "";
    // },
    // finishTask() {
    //   let item = this.params;
    //   let req = {
    //     accountId: this.accountId,
    //     params: JSON.stringify({ id: item.item.id, status: 1 })
    //   };
    //   this.$confirm("Thông báo hoàn thành công việc.", "Warning", {
    //     confirmButtonText: "Xác nhận",
    //     cancelButtonText: "Hủy",
    //     type: "warning"
    //   }).then(async () => {
    //     this.$http.post("/api/todo/status", req).then(s => {
    //       if (s.data.error_code === 0) {
    //         this.alert("success", "Thao tác thành công");
    //       }
    //     });
    //   });
    // }
  },

  created() {},
};
</script>

<style scoped>
</style>